import React, { useEffect } from "react";
import { ModalWrapper } from "./style";
import Button from "../../components/button";

export const Modal = props => {
  const {
    show,
    header,
    body,
    children,
    footer,
    loading,
    close,
    closeHandler,
    height
  } = props;
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);
  return (
    <ModalWrapper
      active={true}
      height={height}
      show={show}
      close={close}
      iconColor={header && header.iconColor}
      buttonAlign={footer && footer.footerAlign}
      bigTitle={header && header.bigTitle}
      hasFooter={!!footer}
      hasHeader={!!header}
    >
      <div
        className="overlay"
        onClick={
          loading
            ? () => false
            : e => {
                e.stopPropagation();
                closeHandler();
              }
        }
      />

      <div className="modal-container">
        <div className="modal-header">
          {header && header.icon && (
            <i
              className={`modal-title-icon no-select ${header && header.icon}`}
            />
          )}
          {header && header.imgIcon && (
            <img
              className="modal-title-icon image"
              src={header && header.imgIcon}
              alt=""
            />
          )}
          {header && header.SvgIcon && (
            <div className="svg-icon-wrapper">
              <header.SvgIcon size={20} />
            </div>
          )}
          <div
            className="modal-header-title"
            dangerouslySetInnerHTML={{
              __html: (header && header.title) || ""
            }}
          />
          <i
            className="modal-close-icon icon mapsa-close no-select"
            onClick={e => {
              e.stopPropagation();
              closeHandler();
            }}
          />
        </div>
        <div className="modal-body">{children || body}</div>
        {footer && (
          <div className="modal-footer">
            {footer.buttons &&
              footer.buttons.map((items, key) => (
                <React.Fragment key={key}>
                  <Button
                    btn={items.buttonType}
                    onClick={e => items.clickHandler && items.clickHandler(e)}
                    loading={items.useLoading && loading}
                    disabled={!items.useLoading && loading}
                    type={items.type ? items.type : "button"}
                    form={items.form}
                  >
                    {items.buttonText}
                  </Button>
                  {(footer.buttons && footer.buttons.length - 1) !== key ? (
                    <div className="button-separator" />
                  ) : (
                    ""
                  )}
                </React.Fragment>
              ))}
          </div>
        )}
      </div>
    </ModalWrapper>
  );
};
